/**
 * Small key-value store for auth data (refresh token, device id, cached user) — decision D6.
 * Backed by the shared IndexedDB; falls back to memory if IndexedDB is unavailable
 * (private mode), which only means the user logs in again after a reload.
 */
import { idbDelete, idbGet, idbSet } from './idb';

const memory = new Map<string, unknown>();

export const kv = {
  async get<T>(key: string): Promise<T | undefined> {
    try {
      const v = await idbGet<T>('kv', key);
      return v ?? (memory.get(key) as T | undefined);
    } catch {
      return memory.get(key) as T | undefined;
    }
  },
  async set(key: string, value: unknown): Promise<void> {
    memory.set(key, value);
    try {
      await idbSet('kv', key, value);
    } catch {
      /* memory fallback already set */
    }
  },
  async del(key: string): Promise<void> {
    memory.delete(key);
    try {
      await idbDelete('kv', [key]);
    } catch {
      /* ignore */
    }
  },
};

export async function getDeviceId(): Promise<string> {
  let id = await kv.get<string>('device_id');
  if (!id) {
    id = crypto.randomUUID();
    await kv.set('device_id', id);
  }
  return id;
}
